import { useDataContext } from '../contexts/DataContext'
import { logoutApi } from '../functions/api'

export const useLogout = () => {
  const {
    setCurrentUserId,
    setCurrentUserRole,
    setCurrentUserFullName,
    setCurrentUserCode,
    setCurrentUserTemporaryPassword,
    setCurrentUserPurchasedRequests,
  } = useDataContext()

  const logout = async () => {
    await logoutApi()

    setCurrentUserId(null)
    setCurrentUserRole(null)
    setCurrentUserFullName(null)
    setCurrentUserCode(null)
    setCurrentUserTemporaryPassword(false)
    setCurrentUserPurchasedRequests(null)
  }

  return { logout }

}